import React from "react";
import { NavLink, Link ,useLocation} from "react-router-dom";
import LazyLoad from "react-lazyload";
import FormAdmissionHome from "./FormAdmissionHome";
import { openAdmissionForm } from "../utils/admissionForm";
const HeaderMUN = () => {
  const handleOpenForm = () => openAdmissionForm();
  const munNavItems = [
    { title: "Home", href: "/" },
    { title: "Itinerary", href: "#itinerary" },
   
    { title: "Download Brochure", href: "#brochure" },
    { title: "Previous MUNs", href: "#previous-muns" },
    { title: "Contact", href: "#contact" },
     { title: "Register Now", href: "https://docs.google.com/forms/d/e/1FAIpQLScgh9Lg6UEaW8WA5-ODzR-N_VV-EosEaKBi1RPQGL_5tzkFCA/viewform?usp=header" },
  ];

  const location = useLocation();
  const handleNavClick = (event, item) => {
    if (item.href === "#contact") {
      event.preventDefault();
      const contactSection = document.getElementById("contact");
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  };
  return (
    <>
      <div className="header header_mun" style={{background :"beige"}}>
        <div className="container-fluid">
          <div className="row" style={{alignItems:"center"}}>
            <div className="col-lg-3 col-md-12">
              <div className="logo">
                <NavLink to="/">
                  <LazyLoad>
                    
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/logo.png"
                      alt="Nirmala Convemt School Rajkot"
                      className="img-fluid"
                    />
                  </LazyLoad>
                </NavLink>
              </div>
            </div>
            <div className="col-lg-9 col-md-12">
              <div className="header-nav">
                <nav className="navbar navbar-expand-lg" style={{background : "unset"}}>
                  <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#main_nav"
                  >
                    <span className="navbar-toggler-icon"></span>
                  </button>
                  <div className="collapse navbar-collapse" id="main_nav">
                    <ul className="navbar-nav">
                      {munNavItems.map((item, index) => (
                        <li
                          className={`nav-item${index === 0 ? " active mun-register-nav-item" : ""}`}
                          key={item.title}
                        >
                          <a
                            className="nav-link"
                            href={item.href}
                            onClick={(event) => handleNavClick(event, item)}
                            target={item.href.startsWith("http") ? "_blank" : undefined}
                            rel={item.href.startsWith("http") ? "noopener noreferrer" : undefined}
                          >
                            {item.title}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

     {!/-mun/i.test(location.pathname) && location.pathname !== "/admission-classxi" && <FormAdmissionHome />}
    </>
  );
};

export default HeaderMUN;
